import React, { useEffect, useState } from 'react'
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang'
import { useSelectorCustom } from '../../../../components/general/general-component/abstruct-component/useSelectorCustom'
import { DeleteComponent } from '../../../../components/general/general-component/abstruct-component/DeleteComponent'
import Table2 from '../../../../components/table/Table2'
import Warning from '../../../../components/general/general-component/warning-delete/Warning'
import { deleteSupply, loadSuppliers } from '../../../../store/Actions/ActionSupply'
import { ColumnSupply } from '../../../../components/general/general-component/columns-component/ColumnSupply'
import { VariableSuppliers } from './VariableSuppliers'
import SectionTopOfTable from '../../../../components/general/general-component/section-top-of-table/SectionTopOfTable'
import FilterSuppliers from './FilterSuppliers'
import InnerLoader from '../../../../components/general/inner-loader/InnerLoader'
import EditProductSupplier from './EditProductSupplier'

const fake = [
    {
        id: 1,
        first_name: "Nour",
        last_name: "kkk",
        material: {
            id: 1,
            name: 'nour'
        },
        company_project: {
            id: 1,
            name: 'nour'
        },
        supplier: {
            id: 1,
            name: 'nour'
        },
        qty: "5555",
        cost: "100",
        currency: "s.p",
        date_of_supply: "2-3-2023",
        time_of_supply: "",
        place_of_supply: "",
        reason_of_supply: "",
    },
]
const Suppliers = () => {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang()
    const { supppliers, loadingSupppliers } = useSelectorCustom()
    const { state, setOpen, handleEdit, setopenEdit } = VariableSuppliers()
    const { stateD, warning, setdeletee, setloadDel } = DeleteComponent()
    const [supppliersArr, setSupppliersArr] = useState([])
    const [isDeleted, setIsDeleted] = useState('')
    const [idDeleted, setIdDeleted] = useState(null)
    useEffect(() => {
        if (isDeleted && idDeleted) {
            const updatedArr = [...supppliersArr];
            const indexToDelete = updatedArr.findIndex(item => item.id === idDeleted);
            if (indexToDelete !== -1) {
                updatedArr.splice(indexToDelete, 1);
                setSupppliersArr(updatedArr);
            }
        }
    }, [isDeleted, idDeleted, supppliersArr]);
    useEffect(() => {
        if (supppliers?.length >= 0) {
            setSupppliersArr(supppliers)
        }
    }, [supppliers]);
    useEffect(() => {
        dispatch(loadSuppliers())
    }, []);
    const handleDelete = (id) => {
        dispatch(deleteSupply(id, setloadDel, setIsDeleted, setIdDeleted));
    }
    const { columns } = ColumnSupply(translate, warning, handleEdit, langLocal)
    return (
        <>
            <>
                <FilterSuppliers translate={translate} bigTitle />

                <div className="div_table2" dir={langLocal == "ar" ? "rtl" : "ltr"} style={{ marginTop: "-20px" }} >
                    <SectionTopOfTable config langLocal={langLocal} />
                    {
                        loadingSupppliers ? <InnerLoader /> :
                            <>
                                <Table2 col={columns} roo={supppliersArr} />
                            </>

                    }
                </div>
            </>
            {
                stateD.deletee == true ? (
                    <Warning loadDel={stateD.loadDel} arr={stateD.arrW} open={stateD.deletee} setOpen={setdeletee} handleDelete={handleDelete} />
                ) : <></>
            }
            {
                state.openEdit && (
                    <EditProductSupplier arr={state.arr1} open={state.openEdit} setOpen={setopenEdit} />
                )
            }
        </>
    )
}

export default Suppliers
